export default function AlignmentToolSelect({
  value,
  onChange,
  options = [],
  placeholder = "Select Alignment Tool",
}) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#EAF4E3] focus:border-[#0B6936]"
    >
      <option value="">{placeholder}</option>

      {options.map((tool) => (
        <option key={tool} value={tool}>
          {tool}
        </option>
      ))}
    </select>
  );
}